<template>
<div class="chapter">
<div class="inner_page">
<div class="chapter">
<p class="calibre2"><span id="Page_12" title="[Pg 12]"></span></p>
<h2 class="nobreak" id="CHAPTER_II">CHAPTER II<br class="calibre4"/>
<span class="fs3">A STRANGE STORY</span></h2>
</div>
<p class="calibre2">Bunny Brown was as much excited and
frightened as his sister, but he did not scream
and call out as Sue did. Instead, Bunny
looked at the man, lying so still and quiet on
the grass. At first the little boy thought the
rider of the runaway horse had been killed
when he had been flung in such a queer way
over the fence.</p>
<p class="calibre2">But as Bunny looked he saw that the
strange man had landed on a pile of grass that
had been cut and raked up that morning by
Bunker Blue, a boy who worked at Mr.
Brown’s fish and boat dock.</p>
<p class="calibre2">“The pile of grass was like a cushion,”
thought Bunny to himself, remembering how
once he had fallen on a pile of hay in a field
when he and his sister were in the country on
Grandpa’s farm. Bunny had not been hurt<span id="Page_13" title="[Pg 13]"></span>
by his fall, and he was hoping the man was
not much hurt by his tumble.</p>
<p class="calibre2">That the man was not dead was proved a
moment later when he moved slightly,
groaned and opened his eyes.</p>
<p class="calibre2">“Hello, what’s your name? Are you much
hurt?” asked Jed Winkler, who was in the
crowd that had rushed up the street after the
runaway.</p>
<p class="calibre2">“My name is Pott—Philip Pott,” was the
faint answer. “I was coming here to look for
my son. He’s lost—my son Harry is lost. At
least, so they say—went down with the
schooner <em class="calibre6">Mary Bell</em>. The treasure is lost too—the
treasure is gone! Oh, if I could only
find my lost son!” Then the man closed his
eyes and lay very quiet.</p>
<p class="calibre2">“He’s a sailor, just as I used to be!” exclaimed
old Jed Winkler, whom Bunny
Brown and his sister knew very well. “He’s
badly hurt, too. He’ll have to lay up in the
sick bay a spell, I reckon! Catch hold of him,
somebody, and we’ll lift him!”</p>
<p class="calibre2">While Bunny Brown and Sue looked on,
their mother and Uncle Tad, an old soldier<span id="Page_14" title="[Pg 14]"></span>
who lived with the Brown family, came out
of the house.</p>
<p class="calibre2">“Bring the poor man into our house,” ordered
Mrs. Brown. “I have telephoned for
the doctor.”</p>
<p class="calibre2">“Oh, Mother! He fell off his horse right
in front of Bunny and me!” exclaimed Sue,
running toward her mother. “We were playing
store!”</p>
<p class="calibre2">“He flew right over the bushes,” added
Bunny.</p>
<p class="calibre2">“Yes, my dears,” said Mrs. Brown. “But
run out of the way now until Uncle Tad and
Mr. Winkler carry the poor man into our
house.”</p>
<p class="calibre2">While this is being done I will take just a
moment to tell my new readers something of
the two children who are to take part in this
story.</p>
<p class="calibre2">Their names, as you have already been told,
were Bunny and Sue Brown. Their father’s
name was Walter Brown. He owned a boat
and fish business in the seacoast town of Bellemere.
He owned a pier which extended out
into Sandport Bay, and to this pier were<span id="Page_15" title="[Pg 15]"></span>
brought the fish which his men caught in nets
off the coast.</p>
<p class="calibre2">The fish were packed in barrels of ice and
shipped to New York and other cities. Mr.
Brown also hired rowboats, sailing craft and
motor launches to those who wanted them.
He had men to help him, and also a chap
named Bunker Blue, who was a big, kindly
lad, very fond of Bunny and Sue. You first
met the children in the book called “Bunny
Brown and His Sister Sue,” which tells of the
funny adventures they had. After that, in
other books, you were told how the children
went to Grandpa’s farm, how they camped,
and of their visit to Aunt Lu, after which they
went to the big woods, then took an auto tour.</p>
<p class="calibre2">Once Bunny and Sue had had a Shetland
pony, and later a trick dog. You may guess
that they were fond of playing store, and once
they helped in a real store. Just before this
story opens, as related in the book, “Bunny
Brown and His Sister Sue at a Sugar Camp,”
the children had gone to the woods toward
the end of winter and had seen how maple
sugar was made.</p>
<p class="calibre2"><span id="Page_16" title="[Pg 16]"></span></p>
<p class="calibre2">Now it was summer again, and Bunny and
Sue were ready for more adventures. But
they were hardly prepared for seeing a man
tossed off the back of a runaway horse, over
their hedge, and almost at their feet.</p>
<p class="calibre2">“Oh, Bunny, do you s’pose he’s dead?”
whispered Sue to her brother as Uncle Tad,
Mr. Winkler, and another man lifted the unconscious
man who had said his name was
Philip Pott.</p>
<p class="calibre2">“I guess he’s not dead,” Bunny answered.
“He couldn’t talk if he was dead.”</p>
<p class="calibre2">“Well, anyhow, maybe he’s hurt,” went on
Sue.</p>
<p class="calibre2">“Yes, I guess he is hurt,” agreed Bunny.</p>
<p class="calibre2">The children started to go into the house,
following the men who were carrying the injured
sailor. Some other men and boys in the
street caught the runaway horse, which had
stopped as soon as it had tossed the man from
his back.</p>
<p class="calibre2">“Whose horse is it?” some one asked.</p>
<p class="calibre2">“It belongs to Jason’s livery stable,” said
Bunker Blue, coming along just then. “That’s
old Jim—I know that horse.”</p>
<p class="calibre2"><span id="Page_17" title="[Pg 17]"></span></p>
<p class="calibre2">“All right, I’ll take him back to Mr. Jason,”
offered Sam Flack, a man who did odd jobs
about the town.</p>
<p class="calibre2">Bunker had come back from the boat and
fish dock to take away the pile of newly cut
grass he had raked up.</p>
<p class="calibre2">“Hi, Bunny, did the horse jump over the
hedge?” asked George Watson, one of Bunny’s
chums. A number of boys and girls had
gathered near the scene of the runaway.</p>
<p class="calibre2">“No, the horse didn’t go over the bushes—just
the man,” said Charlie Star, another chum
of the Brown children.</p>
<p class="calibre2">“How do you know?” asked Harry Bentley.</p>
<p class="calibre2">“I saw him,” answered Charlie.</p>
<p class="calibre2">“So did I!” added Mary Watson. “Oh,
weren’t you ’cited—I mean excited—Sue?”</p>
<p class="calibre2">“Yes, I was,” admitted Sue.</p>
<p class="calibre2">Sue and her brother went into the house,
following the men who had carried in Mr.
Pott, and Bunker Blue “shooed” the other
people out of the yard so he could gather up
the grass. Sam Flack led away the now
quieted horse.</p>
<p class="calibre2">The excitement was over for a time. But<span id="Page_18" title="[Pg 18]"></span>
many things were happening in the home of
Bunny Brown and his sister Sue.</p>
<p class="calibre2">Mrs. Brown and Julia, the maid, had made
ready a couch in one of the rooms, and on this
the silent sailor was laid.</p>
<p class="calibre2">“Does he seem to be badly hurt?” asked
Mrs. Brown of Uncle Tad. “I have telephoned
for Dr. Rudd. He will be here in a
few minutes.”</p>
<p class="calibre2">“He seems to be hurt on the legs and in his
head, Mrs. Brown,” said Jed Winkler. “He’s
a sailor. I gathered that much from his talk.
Do you know him?”</p>
<p class="calibre2">“I never saw him before,” Mrs. Brown answered.
“I was looking out, watching Bunny
and Sue playing store, when I saw this horse
come galloping down the street. Then it
stopped so quickly that the poor man was
pitched off over the hedge.”</p>
<p class="calibre2">“He almost landed on me,” said Bunny.</p>
<p class="calibre2">“On me, too,” added Sue, who did not like
to be left out of anything in which her brother
had a part.</p>
<p class="calibre2">Dr. Rudd came in a few minutes later and
looked Mr. Pott over. The injured sailor<span id="Page_19" title="[Pg 19]"></span>
soon felt better. He opened his eyes and
looked about him.</p>
<p class="calibre2">“Hello! Where am I? What ship is this?”
asked the man in a weak voice.</p>
<p class="calibre2">“You aren’t on any ship, my good man,”
said the doctor. “You are in Mr. Brown’s
house. Can you tell us who you are and
where you want to go?”</p>
<p class="calibre2">The man looked around at the faces, which
were strange to him, and said:</p>
<p class="calibre2">“I don’t know any Mr. Brown.”</p>
<p class="calibre2">“We’re the Browns,” explained Bunny.</p>
<p class="calibre2">“That’s my mother’s name and my father’s
name and Bunny’s name and my name!” exclaimed
Sue. “And you’re in our house.”</p>
<p class="calibre2">“Oh, am I? Thank you, little girl,” said
Mr. Pott, smiling at her. “How did I get
here?”</p>
<p class="calibre2">“You were riding a horse and it ran away
and threw you. Don’t you remember?” asked
Uncle Tad.</p>
<p class="calibre2">“You spoke of the schooner <em class="calibre6">Mary Bell</em>,”
said Jed Winkler. “You’re a sailor, I take it,
same as I used to be. I’m sorry to see you in
trouble, messmate? Can I help you?”</p>
<p class="calibre2"><span id="Page_20" title="[Pg 20]"></span></p>
<p class="calibre2">Mr. Pott looked at Jed Winkler a minute
and then said:</p>
<p class="calibre2">“Well, you might help me if you could find
the lost treasure.”</p>
<p class="calibre2">“What lost treasure?” asked Dr. Rudd, and
Bunny and Sue remembered a sea story their
mother sometimes read to them about a shipwreck
in which treasure had been lost and
later was found on a desert island.</p>
<p class="calibre2">“The treasure was lost on the <em class="calibre6">Mary Bell</em>,”
murmured Mr. Pott. “She foundered, the
<em class="calibre6">Mary Bell</em> did, down in southern waters. I
was first mate aboard of her and my son Harry
was second mate. But I guess he’s lost too—my
boy Harry. He was sick just before the
<em class="calibre6">Mary Bell</em> began to sink. I haven’t had any
word from him since.</p>
<p class="calibre2">“But I thought maybe he got picked up at
sea somehow, and I’ve been going about ever
since, trying to find him. Every time I heard
of a place where a sailor lived I went there,
thinking it might be my son Harry. I thought
maybe he might have the lost treasure. I
heard there was a sailor living here, so I came
to this port.”</p>
<p class="calibre2"><span id="Page_21" title="[Pg 21]"></span></p>
<p class="calibre2">“I guess I’m the only sailor living here,”
said Mr. Winkler. “But I’m not your son and
I haven’t any treasure.”</p>
<p class="calibre2">“You have Wango, your monkey,” said
Bunny, for he and Sue liked the queer, fuzzy,
little animal that Jed had brought back with
him from one of his voyages.</p>
<p class="calibre2">“Yes, I have Wango, but he isn’t any treasure,”
chuckled the old sailor. “Anyhow, my
sister Euphemia doesn’t think so.”</p>
<p class="calibre2">Bunny and Sue well knew this. They wondered
what else the injured sailor would say.
They had listened to his strange story, and
they wondered what his treasure was and if
he would ever find his lost son Harry.</p>
<p class="calibre2">After telling this much about himself Mr.
Pott became unconscious.</p>
<p class="calibre2">“I wanted to ask him how it was he came
to be riding that horse,” said Mr. Winkler.
“A horse is no sort of craft for a sailor.”</p>
<p class="calibre2">“It will be better not to ask him any more
questions for a while,” said Dr. Rudd, “even
if he regains consciousness. Shall I have the
ambulance come and take him away, Mrs.
Brown?”</p>
<p class="calibre2"><span id="Page_22" title="[Pg 22]"></span></p>
<p class="calibre2">“Oh, no, not yet. Let the poor man stay
here,” said Bunny’s mother. “It might hurt
him to move him. Later, if you find he needs
hospital treatment, he can go there. But let
him stay here for the time being.”</p>
<p class="calibre2">So it was arranged, and Dr. Rudd said he
would come in again that afternoon. Bunny
and Sue were looking at the strange sailor
when their mother called:</p>
<p class="calibre2">“Here comes daddy. I suppose he heard
that something had happened at home and
came up from the dock to see about it.”</p>
<p class="calibre2">The footsteps of some one walking in the
hall were heard. Bunny and Sue knew their
father’s tread. Then the voice of Mr. Brown
called:</p>
<p class="calibre2">“Where are you, Bunny? And where’s
Sue? I’ve great news for you!”</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Section0005.vue?340ad5d1